<script lang="ts">
import { defineComponent, ref } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
import ProductListItem from 'components/User/Order/ProductListItem.vue';
import OrderProductList from 'components/User/Order/OrderProductList.vue';
import _ from 'lodash';
import { OrderStore } from 'stores/Order/Order.ts';
import { storeToRefs } from 'pinia';
import { getStatusDetail, OrdersStatuses, RefundCancellationTypes } from 'src/core/constants/Orders';
import OrderService from 'src/core/services/OrderService';
import ChangeAddressDialog from 'components/User/Order/ChangeAddressDialog.vue';
import { AddressItem } from 'src/core/types/Addresses';
import CancelAndRefundDialog from 'components/Product/Order/CancelAndRefundDialog.vue';

export default defineComponent({
  name: 'OrderList',

  components: { CancelAndRefundDialog, ChangeAddressDialog, OrderProductList, ProductListItem, NavigationInnerHead },

  data: () => ({
    siparisUrunList: {},
    model: null,
    options: [
      {
        label: 'Son 30 Gün',
        value: 30,
      },
      {
        label: 'Son 6 Ay',
        value: 183,
      },
      {
        label: 'Son 1 Yıl',
        value: 365,
      },
    ],
    selectByDayModel: null,
  }),

  setup() {
    const orderStore = OrderStore();
    const { orderList } = storeToRefs(orderStore);
    const orderListLoading = ref(false);
    const orderListInfo = ref({
      start: 0,
      limit: 3,
      order: 'desc',
      day: null,
    });

    const pagination = ref({
      current: 1,
      limit: 1,
    });

    function getOrderList() {
      orderListLoading.value = true;
      orderStore
        .userOrderList(orderListInfo.value)
        .then(({ status, data }) => {
          if (status._200_) {
            pagination.value.limit = Math.floor(data.count / orderListInfo.value.limit) || 1;
          }
          orderListLoading.value = false;
        })
        .catch(() => {
          orderListLoading.value = false;
        });
    }

    getOrderList();

    const orderProductsDialog = ref({
      model: false,
      list: null,
    });

    const shippingInfoModal = ref({
      model: false,
      info: null,
      loading: false,
    });

    const changeAddressDialog = ref({
      model: false,
      orderId: 0,
      currAddressId: 0,
      loading: false,
    });

    const cancelAndRefundDialog = ref({
      model: false,
      type: null,
      order: 0,
    });

    return {
      orderList,
      orderListLoading,
      orderProductsDialog,
      orderListInfo,
      getOrderList,
      pagination,
      getStatusDetail,
      shippingInfoModal,
      changeAddressDialog,
      ...OrdersStatuses,
      Refund: RefundCancellationTypes,
      cancelAndRefundDialog,
    };
  },

  methods: {
    /**
     * Sipariş id üzerinden ilgili siparişin data'sını
     * dialog içerisine aktar ve listele
     */
    orderVariationsDialog(orderId: number) {
      const product = _.find(this.orderList.list, (o) => {
        return o.id === orderId;
      });
      this.orderProductsDialog.list = product.products;
      this.orderProductsDialog.model = true;
    },

    selectByDay(day: any) {
      const { value } = day;
      this.orderListInfo.day = value;
      this.getOrderList();
    },

    changePagination() {
      this.orderListInfo.start = (this.pagination.current - 1) * this.orderListInfo.limit;
      this.getOrderList();
      // this.setPageParam();
    },

    openCancelAndRefundDialog(order: any, type: number) {
      this.cancelAndRefundDialog.order = order;
      this.cancelAndRefundDialog.type = type;
      this.cancelAndRefundDialog.model = true;
    },

    setPageParam() {
      this.$router.push({ query: { page: this.pagination.current } });
    },

    showShippingDetail(orderId: number) {
      this.shippingInfoModal.loading = true;
      OrderService.shippingDetail(orderId)
        .then(({ status, data, message }) => {
          if (status._200_) {
            this.shippingInfoModal.info = data;
            this.shippingInfoModal.model = true;
          } else {
            this.$q.notify({
              color: 'red',
              icon: 'fa-solid fa-circle-exclamation',
              message,
            });
          }
          this.shippingInfoModal.loading = false;
        })
        .catch(() => {
          this.shippingInfoModal.loading = false;
        });
    },

    openChangeAddressDialog(orderId: number, currAddressId: number) {
      this.changeAddressDialog.orderId = orderId;
      this.changeAddressDialog.currAddressId = currAddressId;
      this.changeAddressDialog.model = true;
    },

    changeAddressForOrder(address: AddressItem) {
      // change address service
      const { orderId } = this.changeAddressDialog;
      const { id } = address;

      this.changeAddressDialog.loading = true;
      OrderService.changeAddress({ orderId, addressId: id })
        .then(({ status, message }) => {
          if (status._200_) {
            this.$q.notify({
              color: 'green',
              icon: 'fa-regular fa-circle-check',
              message: 'Sipari için adres değişikliği yapılmıştır',
            });
            this.changeAddressDialog.currAddressId = id;
            this.changeAddressDialog.model = false;
            this.getOrderList();
          } else {
            this.$q.notify({
              color: 'red',
              icon: 'fa-solid fa-circle-exclamation',
              message,
            });
          }
          this.changeAddressDialog.loading = false;
        })
        .catch(() => {
          this.changeAddressDialog.loading = false;
        });
    },
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex justify-between items-center q-mb-md">
      <div>
        <navigation-inner-head title="Siparişler" icon="shopping_basket" />
      </div>
      <div>
        <q-select
          dense
          label="Siparişleri Filtrele"
          standout="bg-secondary text-white"
          v-model="selectByDayModel"
          rounded
          option-label="label"
          transition-show="flip-up"
          transition-hide="flip-down"
          :options="options"
          @update:modelValue="selectByDay"
          style="width: 250px"
          @update:model-value="selectByDay"
        >
          <template v-slot:after>
            <q-btn flat round dense icon="close" @click="selectByDayModel = null" v-if="selectByDayModel">
              <q-tooltip>Temizle</q-tooltip>
            </q-btn>
          </template>
        </q-select>
      </div>
    </div>
    <q-separator color="accent" />
    <div class="row">
      <div v-if="orderListLoading" class="col-12 q-pa-sm">
        <div style="width: 100%" class="text-center">
          <q-linear-progress color="primary" indeterminate class="q-mb-lg" />
          <span class="text-h6 text-weight-bold">Siparişleriniz Yükleniyor</span>
        </div>
      </div>
      <div v-else class="col-12 q-py-lg">
        <div>
          <div class="order-list-box rounded-borders overflow-hidden q-mb-xl" :key="key" v-for="(order, key) in orderList.list">
            <div class="siparis-box-ust bg-primary text-white q-pa-sm">
              <div class="row">
                <div class="col-xs-12 col-md-4">
                  <p class="q-mb-xs">
                    <span class="text-subtitle1 text-weight-bold text-grey-1">Sipariş Tarihi</span>
                    <br />
                    {{ $dayjs(order.orderdate).format('DD/MM/YYYY - HH:mm') }}
                  </p>
                </div>
                <div class="col-xs-12 col-md-4">
                  <p class="text-center q-mb-xs q-mb-none">
                    <span class="text-subtitle1 text-weight-bold text-grey-1">Sipariş Kodu</span>
                    <br />
                    {{ order.kod }}
                  </p>
                </div>
                <div class="col-xs-12 col-md-4 flex justify-end">
                  <p class="text-center q-mb-xs">
                    <span class="text-subtitle1 text-weight-bold text-grey-1">Ödenen Tutar</span>
                    <br />
                    <strong>{{ $numberToCurrency(order.amount) }} ₺</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="siparis-box-orta bg-grey-2 q-pa-sm">
              <div class="row">
                <div v-if="order.status === ORDER_CREATED" class="col-xs-12 flex justify-between items-center">
                  Siparişiniz henüz tamamlanmamış.
                  <q-btn color="primary" :to="`/complete-order/${order.id}`" class="complete-order-btn" no-caps>
                    SİPARİŞİ TAMAMLA
                    <q-icon name="fa-solid fa-right-long" size="1rem" class="q-ml-sm" />
                  </q-btn>
                </div>
                <div v-else class="row col-xs-12 flex justify-between">
                  <div class="col-lg-7 column justify-between">
                    <p class="q-mb-xs">
                      <span class="text-subtitle2 text-weight-regular text-grey-8">Adres:</span>
                      <br />
                      <span class="text-weight-bold">{{ order.address_namesurname }}</span>
                      <br />
                      {{ order.address_address }}
                      <br />
                      {{ order.address_district }}, {{ order.address_city }} ({{ order.address_postcode }})
                    </p>
                    <div v-if="[WAITING_FOR_APPROVAL, ORDER_CONFIRMED, BEING_PREPARED].includes(order.status)">
                      <q-btn
                        no-caps
                        small
                        unelevated
                        rounded
                        color="secondary"
                        dense
                        class="q-py-none"
                        style="padding: 0 0.75rem"
                        @click="openChangeAddressDialog(order.id, order.address)"
                      >
                        <q-icon name="edit" size="1rem" left></q-icon>
                        Adresi Değiştir
                      </q-btn>
                    </div>
                  </div>
                  <div class="col-lg-5 column items-end">
                    <div class="flex justify-end q-mb-sm">
                      <q-chip color="primary" text-color="white">{{ getStatusDetail(order.status).statusText }}</q-chip>
                    </div>
                    <div v-if="order.status === ORDER_SHIPPED" class="flex justify-center">
                      <q-btn
                        rounded
                        no-caps
                        color="green"
                        dense
                        size="small"
                        unelevated
                        class="q-px-md"
                        :loading="shippingInfoModal.loading"
                        @click="showShippingDetail(order.id)"
                      >
                        <q-icon name="info" size="1rem" left></q-icon>
                        <span>Kargo Bilgileri</span>
                      </q-btn>
                    </div>
                    <div
                      v-if="
                        [WAITING_FOR_APPROVAL, ORDER_CONFIRMED, BEING_PREPARED, WILL_BE_SHIPPED, ORDER_PENDING, ORDER_CREATED].includes(order.status) &&
                        order.refundOrCancellation
                      "
                      class="flex justify-center q-mt-sm"
                    >
                      <q-btn
                        rounded
                        no-caps
                        color="red-10"
                        dense
                        size="small"
                        unelevated
                        class="q-px-md"
                        @click="openCancelAndRefundDialog(order, Refund.ORDER_CANCELLATION)"
                      >
                        <q-icon name="swipe_vertical" size="1.2rem" left></q-icon>
                        <span>İptal Talebi</span>
                      </q-btn>
                    </div>
                    <div v-else-if="[ORDER_COMPLETED, ORDER_SHIPPED].includes(order.status) && order.refundOrCancellation" class="flex justify-center q-mt-sm">
                      <q-btn rounded no-caps color="red-10" dense size="small" unelevated class="q-px-md" @click="openCancelAndRefundDialog(order, Refund.ORDER_REFUND)">
                        <q-icon name="swipe_vertical" size="1.2rem" left></q-icon>
                        <span>İade Talebi</span>
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="siparis-box-alt bg-grey-2">
              <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="urunler-box bg-secondary text-white text-caption q-px-sm q-py-xs">Satın alınan ürünler</div>
                  <q-list>
                    <product-list-item :list="order.products" :count="1" />
                    <q-item class="bg-grey-3">
                      <q-item-section>
                        <q-item-label class="text-center">
                          <q-btn
                            unelevated
                            label=""
                            class="see-all-products-btn text-capitalize"
                            color="secondary"
                            max-width="150px"
                            size=".75rem"
                            @click="orderVariationsDialog(order.id)"
                          >
                            <q-icon name="fa-solid fa-angles-right" size=".75rem" />
                            <span class="q-px-sm">Tüm Ürünleri Görüntüle</span>
                            <q-icon name="fa-solid fa-angles-left" size=".75rem" />
                          </q-btn>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </div>
              </div>
            </div>
          </div>
          <div class="q-px-lg flex flex-center">
            <q-pagination v-model="pagination.current" :max="pagination.limit" input @update:model-value="changePagination" />
          </div>
          <order-product-list v-model="orderProductsDialog.model" :list="orderProductsDialog.list" />
        </div>
      </div>
    </div>
    <!--  Shipping Detail Dialog  -->
    <q-dialog v-model="shippingInfoModal.model">
      <q-card>
        <q-toolbar class="q-py-md">
          <q-avatar>
            <img src="/img/fast-delivery.png" width="30px" />
          </q-avatar>

          <q-toolbar-title><span class="text-weight-bold">Kargo Bilgileri</span></q-toolbar-title>

          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>
        <hr class="grey q-my-none" />
        <q-card-section>
          <div class="text-body1">
            <div class="q-mb-sm"><strong>Kargo: </strong> {{ shippingInfoModal.info.name }}</div>
            <div><strong>Kargo Takip Numarası: </strong>{{ shippingInfoModal.info.number }}</div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <!--  ./Shipping Detail Dialog  -->

    <!--  Change Address List  -->
    <change-address-dialog
      v-model="changeAddressDialog.model"
      :config="{ loading: changeAddressDialog.loading, currAddressId: changeAddressDialog.currAddressId }"
      @change="changeAddressForOrder"
    />
    <!--  ./Change Address List  -->
  </q-card>

  <cancel-and-refund-dialog v-model="cancelAndRefundDialog.model" :order="cancelAndRefundDialog.order" :type="cancelAndRefundDialog.type" />
</template>

<style scoped>
.complete-order-btn,
.see-all-products-btn {
  font-family: system-ui, -apple-system, Helvetica, sans-serif;
  letter-spacing: 0.035rem;
  font-weight: bold;
}

.order-list-box {
  border: 1px solid #dedede;
}
</style>
